module.exports = __webpack_public_path__ + "static/media/icon8-1.067c0d79.png";